import _orderBy from 'lodash/orderBy'
import { fetchPMMEquipments } from 'frontend/communications/apiClient'
import { PROMISE_STATUS } from 'frontcore/constants/promises'

const stateObj = {
  pmmEquipments: [],
  pmmEquipmentsLoadingStatus: PROMISE_STATUS.notStarted,
  pmmEquipmentsPromise: null,
}
  
const getters = {
  getPMMEquipments (state) {
    return state.pmmEquipments
  },
  pmmEquipmentsAreLoaded (state) {
    return state.pmmEquipmentsLoadingStatus === PROMISE_STATUS.complete
  },
}
  
const mutations = {
  setPMMEquipments (state, equipments) {
    state.pmmEquipments = _orderBy(equipments, 'equipment_id')
  },
  setPmmEquipmentsLoadingStatus (state, status) {
    state.pmmEquipmentsLoadingStatus = status
  },
}
  
const actions = {
  fetchPMMEquipments ({ commit, state }, force = false) {
    if (state.pmmEquipmentsLoadingStatus !== PROMISE_STATUS.complete || force) {
      state.pmmEquipmentsPromise = fetchPMMEquipments()
      commit('setPmmEquipmentsLoadingStatus', PROMISE_STATUS.pending)
    }
    return !state.pmmEquipmentsPromise ? state.pmmEquipments : state.pmmEquipmentsPromise.then((pmmEquipments) => {
      commit('setPMMEquipments', pmmEquipments)
      commit('setPmmEquipmentsLoadingStatus', PROMISE_STATUS.complete)
      return pmmEquipments
    }).catch(e => {
      throw e
    }).finally(() => {
      state.standardsPromise = null
    })
  },
}
  
export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
